import { basisPointsToPercent } from 'features/deals/DealStages/EventActionCards/utils';

export function calculateNetYieldAtPrice(
  netWeightedAverageCoupon: number,
  bidBasisPoints?: number | null,
): string {
  if (!Number.isFinite(netWeightedAverageCoupon)) {
    return '-';
  }

  if (bidBasisPoints === null || bidBasisPoints === undefined) {
    return '-';
  }

  const pricePercent = parseFloat(basisPointsToPercent(bidBasisPoints));
  if (!Number.isFinite(pricePercent) || pricePercent === 0) {
    return '-';
  }

  return ((100 * netWeightedAverageCoupon) / pricePercent).toFixed(3) + '%';
}
